/// #if DEBUG
// import { urlMap } from '@/app/components/Debugger/ctl';
/// #endif
// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import getRequest from '@ys/web-common-repo/dist/service/base';

import { LOGIN_PAGE_URL, RESPONSE_CODE } from './config/index';
// import { expTrackIns, trackAction } from '@/context/track';
// import { customTrace } from '@/lib/customLog';
import { getSmDeviceId } from './smLib/sm-sdk';
import type { MessageEnd, MessageReplace, ThoughtItem } from './type/chat';
import {
  clearLoginCookieInfo,
  fetchData,
  // getAuthByCookie,
  // getLoginTokenCookie,
  // getVisitorIdByCookie,
} from './utils/index';
// import { signFn } from './sign';

// 定义API响应和错误的类型
// interface ApiResponse {
//   config?: {
//     url?: string;
//     meta?: {
//       startTime: number;
//     };
//     headers?: Record<string, any>;
//     data?: any;
//   };
//   status?: number;
//   data?: {
//     code?: number;
//     msg?: string;
//     [key: string]: any;
//   };
//   response?: ApiResponse; // 嵌套响应，用于错误对象中的response属性
// }

// const region = process.env.NEXT_PUBLIC_BUSINESS_REGION;
export const baseRequest = getRequest({
  appName: 'wanyu',
  // 2.8.0版本以后，对话列表接口支持返回botInfo
  appVersion: '2.8.0',
  appVersionCode: '2.1.5',
  timeZone: 'ny',
});

// const err500Reg = /^5[0-9]*/;
// const okReg = /^2[0-9]{3}/;

// const TIME_OUT = 100000;

export const ContentType = {
  json: 'application/json',
  stream: 'text/event-stream',
  form: 'application/x-www-form-urlencoded; charset=UTF-8',
  download: 'application/octet-stream', // for download
  upload: 'multipart/form-data', // for upload
};

// const baseOptions = {
//   method: 'GET',
//   mode: 'cors',
//   credentials: 'include', // always send cookies、HTTP Basic authentication.
//   headers: new Headers({
//     'Content-Type': ContentType.json,
//   }),
//   redirect: 'follow',
// };

export type IOnDataMoreInfo = {
  conversationId?: string;
  taskId?: string;
  messageId: string;
  errorMessage?: string;
  errorCode?: string;
};

export type IOnData = (
  message: string,
  isFirstMessage: boolean,
  moreInfo: IOnDataMoreInfo
) => void;
export type IOnThought = (though: ThoughtItem) => void;
export type IOnMessageEnd = (messageEnd: MessageEnd) => void;
export type IOnMessageReplace = (messageReplace: MessageReplace) => void;
export type IOnCompleted = (hasError?: boolean) => void;
export type IOnError = (msg: string, code?: string) => void;

// type IOtherOptions = {
//   isPublicAPI?: boolean;
//   bodyStringify?: boolean;
//   needAllResponseContent?: boolean;
//   deleteContentType?: boolean;
//   onData?: IOnData; // for stream
//   onThought?: IOnThought;
//   onMessageEnd?: IOnMessageEnd;
//   onMessageReplace?: IOnMessageReplace;
//   onError?: IOnError;
//   onCompleted?: IOnCompleted; // for stream
//   getAbortController?: (abortController: AbortController) => void;
// };

//  TODO: 待补充
// type FetchOptionType = {
//   params: any;
//   body: any;
// };

// const baseRequest = axios.create({ timeout: TIME_OUT });

/**
 * 提取并清理 API URL
//  */
// function extractCleanUrl(config?: any, response?: any): string {
//   const url = config?.url || response?.config?.url || '';
//   return url.split('?')[0];
// }

/**
 * 上报API性能指标
 * @param response API响应对象
 */
// function reportApiConsumption() {
//   // response: ApiResponse
//   try {
//     // 提取基本信息
//     // const endTime = new Date().getTime();
//     // const duration = response.config?.meta
//     //   ? endTime - response.config.meta.startTime
//     //   : -1;
//     // const url = response.config?.url || '';
//     // const cleanUrl = url.split('?')[0];
//     // const success =
//     //   response.status && response.status >= 200 && response.status < 300;
//     // 自定义日志追踪
//     // customTrace(EVENT_NAME.API_RESP_CONSUMPTION, {
//     //   msg: JSON.stringify({
//     //     url: cleanUrl,
//     //     start_time: response.config?.meta?.startTime,
//     //     end_time: endTime,
//     //     duration,
//     //   }),
//     // });
//     // 内部埋点上报
//     // if (expTrackIns && typeof (expTrackIns as any).track === 'function') {
//     //   (expTrackIns as any).track('api', {
//     //     bhv_type: 'network',
//     //     url: cleanUrl,
//     //     duration,
//     //     status_code: response.status,
//     //     api_code: response.data?.code,
//     //     config: JSON.stringify(response.config),
//     //     data: JSON.stringify(response.data),
//     //   });
//     // }
//   } catch (e) {
//     console.log('Error in reportApiConsumption:', e);
//   }
// }

// function reportApi(response: ApiResponse) {
//   // customTrace(EVENT_NAME.API_RESP_LOG, {
//   //   msg: JSON.stringify({
//   //     url: response.config?.url,
//   //     ...response,
//   //   }),
//   // });
// }

baseRequest.interceptors.response.use(
  (response: any) => {
    //  api上报
    // console.log('response: ', response)
    // reportApiConsumption(response);

    const { data } = response;
    const { code } = data || {};
    switch (code) {
      case RESPONSE_CODE.SUCCESS:
        // reportApi(response);
        return data;
      case RESPONSE_CODE.NEED_LOGIN:
      case RESPONSE_CODE.LOGIN_IS_BANNED:
      case RESPONSE_CODE.TOKEN_INVALID:
      case RESPONSE_CODE.TOKEN_EXPIRE:
      case RESPONSE_CODE.TOKEN_REQUIRE:
      case RESPONSE_CODE.VISITORID_REQUIRE:
      case RESPONSE_CODE.VISITORID_EXPIRE:
      case RESPONSE_CODE.VISITORID_MISMATCH:
      case RESPONSE_CODE.VISITORID_INVALID: {
        //  TODO
        // trackAction('TOKEN_ACTION_API_CLEAR', {
        //   auth: JSON.stringify(getAuthByCookie()),
        //   visitorId: getVisitorIdByCookie(),
        //   loginToken: getLoginTokenCookie(),
        // });
        clearLoginCookieInfo();
        if (window?.location?.pathname !== LOGIN_PAGE_URL) {
          window.location.href = LOGIN_PAGE_URL;
        }
        // safeTrackApiError(response);
        return;
      }
      default:
        // safeTrackApiError(response);
        return data;
    }
  },
  (error: any) => {
    // console.log('response: ', error);
    // reportApiConsumption(error);
    // safeTrackApiError(error.response || error);
    // if (error && error.response) {
    //   switch (error.response.status) {
    //     case 401:
    //       deleteCookie('login');
    //       globalThis.location.href = loginUrl;
    //       return;
    //   }
    // }
    console.log('req error', error);
    // const region = process.env.NEXT_PUBLIC_BUSINESS_REGION;
    return {
      code: 999,
      msg: 'Network error, please try again.',
    };
  }
);

const appendCommonHeader = async (config: any) => {
  try {
    let headers = config?.headers || {};
    // const smDId = await getSmDeviceId();

    // headers['X-Yuanshi-SM-DeviceId'] = smDId;
    config.headers = headers;
  } catch (e: any) {
    console.warn(e.message);
  }
};

//请求头添加webId
const addWebIdHeader = async (config: any) => {
  try {
    const webId = localStorage.getItem('webId') || '';
    const traffic_source = localStorage.getItem('traffic_source') || '{}';

    config.headers = {
      ...config.headers,
      'X-Yuanshi-source': JSON.stringify({ volc_did: webId || '' }),
      'X-Yuanshi-Traffic-Source': traffic_source,
    };
  } catch (e) {
    console.error(e);
  }
};

const request = async (config: any) => {
  if (config == null) {
    throw new Error('Invalid request config.');
  }

  //  api性能上报数据
  config.meta = { startTime: Date.now() };

  /// #if DEBUG
  // urlMap(config);
  /// #endif
  if (!localStorage.getItem('mistiming')) {
    await fetchData();
  }

  await appendCommonHeader(config);
  // config = signFn(config);
  // console.log('jst', config);

  //统一给客户端接口添加请求头X-Yuanshi-source,值为火山webId,服务端暂不需要
  await addWebIdHeader(config);

  // 标记这是一个需要监控的请求，但由统一的 MonitoringProvider 来处理
  config.__trackingMeta = {
    isServiceRequest: true,
    startTime: Date.now(),
  };
  return baseRequest(config);
};

export default request;
